import qs from 'qs';

import { Http } from './http.init';
import { ResponseWrapper, ErrorWrapper } from './util';

export class Service {
  static request(meta = { auth: true }) {
    return new Http(meta);
  }

  static responseWrapper(...rest) {
    return new ResponseWrapper(...rest);
  }

  static errorWrapper(...rest) {
    return new ErrorWrapper(...rest);
  }

  static querystring(obj) {
    return qs.stringify(obj, {
      encode: false
    });
  }
}
